import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  min-width: 750px;
`;

export const Container = styled.div`
  overflow: auto;
`;

export const TRow = styled.tr`
  border-bottom: 1px solid #ebebeb;
`;

export const GrayText = styled.p`
  color: ${(props) => props.theme.colors['neutral-80']};
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  padding: 12px 0;
  text-align: start;
`;

export const GrayTextLine = styled.p`
  color: ${(props) => props.theme.colors['neutral-80']};
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  text-align: start;
  margin-top: 22px;
  position: absolute;
`;

export const TdLabels = styled.td`
  vertical-align: baseline;
`;

export const TData = styled.td`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  padding-top: 8.5px;
`;

export const TDataButton = styled.td`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  vertical-align: baseline;
  padding-top: 15px;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: ${({ theme }) => theme.colors['neutral-30']};
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  padding: 3px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.colors['neutral-20']};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors['neutral-40']};
  }

  input {
    display: none;
  }
`;

export const TFileName = styled.a`
  color: ${(props) => props.theme.colors['primary-60']};
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  display: block;
  padding: 12px 0;
  width: 15vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CellContent = styled.span`
  display: block;
  padding: 12px 0;
`;

export const DownloadBtn = styled.a`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${(props) => props.theme.colors['primary-60']};
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
`;

export const ButtonContent = styled.span`
  display: flex;
  justify-content: flex-end;
  padding: 6px 0;
`;

export const SmallTH = styled.th`
  width: 88px;
`;

export const MediumTH = styled.th`
  width: 112px;
`;

export const LargeTH = styled.th`
  width: 180px;
`;
